import { deck2029 } from './2029/deck';

const decksById = {
  '2029': deck2029
};

export function getDeckDefinition(deckId) {
  const resolved = deckId || '2029';
  const deck = decksById[resolved];
  if (!deck) {
    return decksById['2029'];
  }
  return deck;
}
